export default __webpack_public_path__ + "static/media/24h.3907e873.svg";